<!-- MOCKUP: hasCarbonFootprint, campaign y crops son datos simulados en el componente TS.
     TODO (backend): cuando company.carbon_footprint esté disponible, solo verificar que
     los bindings {{ campaign }} y {{ crops }} reflejen los datos reales. -->
<ng-container *ngIf="company && hasCarbonFootprint">
  <span class="ag-label label-success carbon-footprint-badge"
     [popover]="carbonFootprintPopover"
     triggers="mouseenter:mouseleave"
     placement="right"
     container="body"
     containerClass="popFadeDelay">
    <span class="glyphicon glyphicon-leaf" aria-hidden="true"></span> Huella de carbono
  </span>
</ng-container>

<ng-template #carbonFootprintPopover>
  <!-- TODO (backend): revisar si el texto "campaña actual" sigue siendo correcto cuando
       el backend pueda devolver campañas pasadas. -->
  <p class="small">Este productor midió su huella de carbono en la campaña actual.</p>
  <p class="small"><b>Campaña:</b> {{ campaign }}</p>
  <hr class="carbon-footprint-popover-divider">
  <div *ngFor="let crop of cropStats" class="carbon-footprint-crop-stats">
    <p class="small"><b>{{ crop.name }}</b></p>
    <p class="small">{{ crop.measuredHectares | number:'1.0-0':'es-AR' }} hectáreas medidas</p>
    <p class="small">{{ crop.sustainableTons | number:'1.0-0':'es-AR' }} toneladas sustentables</p>
  </div>
</ng-template>
